import React from "react"
import { Col, Row } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { FormOptionsComponentProps } from "../../../common/types/integration"
import IntlProps from "../../../state/helpers/IntlProps"
import { WIX_FEATURE_SETTINGS } from "../../../state/integration/IntegrationFeatureSettings"
import { ExternalForm } from "../../../state/integration/wix/types"
import { EXTERNAL_FORM_MESSAGES } from "../../../utils/external-forms/message"
import FeatureToggleComponent from "../FeatureToggleComponent"
import LoadExternalFormsComponent from "./LoadExternalFormsComponent"

const FormOptionsComponent = (props: FormOptionsComponentProps & IntlProps) => {
    const handleFormChange = (selectedForm: ExternalForm) => {
        props.onExternalFormSetCallback(selectedForm)
    }

    return  <div>
        <FeatureToggleComponent
            featureKey={WIX_FEATURE_SETTINGS.CreateFormOnSubmission}
            checked={props.createQuoteOnFormSubmission}
            onFeatureToggled={() => {
                props.onToggleChange()
            }}
            renderFeatureLabel={() => {
                return props.intl.formatMessage(EXTERNAL_FORM_MESSAGES.create_form_label)
            }}
        />
        {props.createQuoteOnFormSubmission && (
            <div>
                <Row className="pb-2">
                    <Col md={3} className="text-right align-self-center">
                        <label className="col-form-label" htmlFor="name">
                            {props.intl.formatMessage(EXTERNAL_FORM_MESSAGES.select_form_label)}
                        </label>
                    </Col>
                    <Col md={6} className="align-items-center">
                        <LoadExternalFormsComponent
                            onFormSelectedCallback={handleFormChange}
                            selectedForm={props.mappedForm !== ""
                                ? { value: props.mappedForm, label: props.mappedForm}
                                : props.selectedForm?.displayName
                            }
                        />
                    </Col>
                </Row>
            </div>
        )}
    </div>
}

export default injectIntl(FormOptionsComponent)


// WEBPACK FOOTER //
// ./src/integration/form/wix/FormOptionsComponent.tsx